import { api } from './client';
import type { ApiResponse } from './types';

export interface EventFacet {
  code: string;
  dimension: string;
  label: string;
  description: string;
}
export interface EventAttributeSuggestion {
  code: string; label: string; description: string; source: string;
  evidenceText: string | null; sourceModel: string | null; stale: boolean;
}
export const getEventSuggestions = (eventId: string) =>
  api.get<ApiResponse<{ eventId: string; revision: number; suggestions: EventAttributeSuggestion[] }>>(`/events/${eventId}/graph/suggestions`);
export interface EventGraph {
  eventId: string;
  revision: number;
  canonical: {
    languages: string[];
    relatedStates: string[];
    foodInfo: string | null;
    festivalCode: string | null;
    rituals: string[];
    tradition: string | null;
  };
  facets: Array<EventFacet & {
    active: boolean;
    source: string;
    organizerConfirmedAt: string;
  }>;
}
export const getEventFacets = () =>
  api.get<ApiResponse<{ facets: Array<EventFacet & { aliases: string[] }> }>>('/events/facets');
export const getEventGraph = (eventId: string) =>
  api.get<ApiResponse<EventGraph>>(`/events/${eventId}/graph`);
export const saveEventGraph = (eventId: string, expectedRevision: number, facetCodes: string[], confirmationReceipt?: string) =>
  api.patch<ApiResponse<EventGraph>>(`/events/${eventId}/graph`, { expectedRevision, facetCodes, confirmationReceipt });
